import styled from 'styled-components';
import { IconButton } from '@mui/material';

export const Button = styled(IconButton)``;
